import styled from 'styled-components';

export const CheckBoxWrapper = styled.div`
	margin: 6px;
`;
